// #/reset-demo (LOT 7c §5) — écran de réinitialisation démo, JAMAIS exposé
// dans l'UI de service (route non liée : à taper à la main). Deux temps :
// confirmation EXPLICITE, puis bilan « toutes tables = 0 » + reload. Zéro
// animation, éléments maison.
import { useState } from 'react';
import { resetDemo, type ResetDemoBilan } from '@/db/reset-demo';

interface Props {
  /** Injectable en test (jsdom n'implémente pas reload). */
  onRecharger?: () => void;
}

export function ResetDemoScreen({ onRecharger }: Props) {
  const [bilan, setBilan] = useState<ResetDemoBilan | null>(null);

  const recharger = (): void => {
    if (onRecharger) onRecharger();
    else window.location.reload();
  };

  if (bilan === null) {
    return (
      <div
        data-testid="reset-confirm"
        className="fixed inset-0 z-50 flex items-center justify-center bg-ardoise/40 p-6"
      >
        <div className="flex w-full max-w-2xl flex-col gap-6 rounded-xl border-4 border-destructive bg-creme p-8">
        <p className="font-cormorant text-4xl italic text-ardoise">
          Réinitialiser la démo ?
        </p>
        <p className="font-jost text-2xl text-ardoise">
          TOUTES les données locales seront effacées : commandes, clients,
          catalogue, sessions, réglages Tablier. Action irréversible.
        </p>
        <div className="flex gap-4">
          <button
            type="button"
            onClick={() => {
              window.location.hash = '#/t2';
            }}
            className="min-h-[120px] flex-[2] rounded-lg bg-ardoise font-jost text-2xl text-creme"
          >
            RETOUR
          </button>
          <button
            type="button"
            onClick={() => void resetDemo().then(setBilan)}
            className="min-h-[120px] flex-1 rounded-lg bg-destructive font-jost text-2xl text-destructive-foreground"
          >
            TOUT EFFACER
          </button>
        </div>
        </div>
      </div>
    );
  }

  return (
    <div
      data-testid="reset-bilan"
      className="fixed inset-0 z-50 flex items-center justify-center bg-ardoise/40 p-6"
    >
      <div className="flex max-h-[90vh] w-full max-w-2xl flex-col gap-5 overflow-auto rounded-xl border-4 border-ardoise bg-creme p-8">
      <h2 className="font-cormorant text-4xl italic text-ardoise">
        Démo réinitialisée
      </h2>
      <dl className="flex flex-col gap-2 font-jost text-xl text-ardoise">
        {Object.entries(bilan.tables).map(([nom, compte]) => (
          <div key={nom} className="flex justify-between gap-6">
            <dt>{nom}</dt>
            <dd className="font-mono" data-testid={`reset-table-${nom}`}>
              {compte}
            </dd>
          </div>
        ))}
        <div className="flex justify-between gap-6">
          <dt>clés locales purgées</dt>
          <dd className="font-mono" data-testid="reset-cles">
            {bilan.clesPurgees}
          </dd>
        </div>
      </dl>
      <button
        type="button"
        onClick={recharger}
        className="min-h-[96px] rounded-lg bg-ardoise font-jost text-2xl text-creme"
      >
        RECHARGER L&apos;APPLICATION
      </button>
      </div>
    </div>
  );
}
